import React from 'react';
import { useTranslation } from 'react-i18next';

import { useFilterAuthorities } from 'api';
import { filterAuthorityState } from 'store';
import { ConsultationFilterMultiSelect } from 'components';
import { useThemedValueSwitch } from '@tq/ui-components/dist/hooks';

export const ConsultationAuthorityFilter: React.FC = () => {
  const { t } = useTranslation('filter');
  const { data: authorityData } = useFilterAuthorities();
  const { isTQ } = useThemedValueSwitch();

  return (
    <ConsultationFilterMultiSelect
      label={
        isTQ ? t('municipality_title', 'Municipality') : t('authority_title', 'Authority')
      }
      items={authorityData?.authorities}
      state={filterAuthorityState}
    />
  );
};
